// extracted by mini-css-extract-plugin
module.exports = {"content":"ShowMoreText_content__ChE2Q","showMoreContainer":"ShowMoreText_showMoreContainer__25fmQ","extendedContainer":"ShowMoreText_extendedContainer__3fTNj"};